import React, { useState } from "react";
import styles from "../../assets/scss/HelpCenterNormalUser/HelpCenterUserView.module.scss";
import Pagination from "../../Components/Common/Pagination";
import { useNavigate, useLocation } from "react-router-dom";
import PopupWrapper from "../../Components/Common/PopupWrapper";
import HelpCenterUserAdminAdd from "./HelpCenterUserAdminAdd";
import { useDeleteEnquiryResponseMutation, useGetEnquiryResponsesQuery } from "../../slices/admin/admin";
import { FaEdit, FaTrash } from "react-icons/fa";
import DeleteConfirmModalLogout from "../../Components/Common/DeleteConfirmModalLogout";

const HelpCenterAdminView = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const enquiryId = location.state?.enquiryId;

    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [showPopup, setShowPopup] = useState(false);

    const [editData, setEditData] = useState(null);
    const [deleteResponse] = useDeleteEnquiryResponseMutation();

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const confirmDelete = async () => {
        if (!selectedItem?._id) return;

        try {
            await deleteResponse(selectedItem._id).unwrap();
            setDeleteModalOpen(false);
            setSelectedItem(null);
            refetch();
        } catch (error) {
            console.error("Delete failed:", error);
        }
    };



    /* ✅ API CALL */
    const { data, isLoading, refetch } = useGetEnquiryResponsesQuery(
        {
            enquiryId,
            offset: currentPage,
            limit,
        },
        {
            skip: !enquiryId,
        }
    );
    const tableDataHead = data;

    //console.log("tableDataHead", tableDataHead);


    const tableData = data?.data || [];    
    const totalCount = data?.total || 0;
    const totalPages = Math.ceil(totalCount / limit);

    return (
        <div className={styles.billingContainer}>
            {/* HEADER */}
            <div className={styles.header}>
                <h2 className={styles.tittle}>Ticket Responses</h2>
                <span
                    className={styles.closeIcon}
                    onClick={() => navigate("/dashboard/HelpCenterAdmin")}
                >
                    ✕
                </span>
            </div>

            <div className={styles.billingContainers}>
                <div className={styles.itemsSection}>
                    <div className={styles.itemsHeader}>
                        <h4>{tableDataHead?.comments} - {tableDataHead?.queries}</h4>

                        <button
                            className={styles.addBtn}
                            onClick={() => setShowPopup(true)}
                        >
                            Add New Ticket Response
                        </button>
                    </div>

                    <div className={styles.tableWrapper}>
                        <table>
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>User Name</th>
                                    <th>Comments</th>
                                    <th>Mode of Contact</th>
                                    <th>Status</th>
                                    <th>Created At</th>
                                    {/* <th>Actions</th> */}
                                </tr>
                            </thead>

                            <tbody>
                                {isLoading && (
                                    <tr>
                                        <td colSpan={6} className={styles.noData}>
                                            Loading...
                                        </td>
                                    </tr>
                                )}

                                {!isLoading && tableData.length === 0 && (
                                    <tr>
                                        <td colSpan={6} className={styles.noData}>
                                            No records found
                                        </td>
                                    </tr>
                                )}

                                {!isLoading &&
                                    tableData.map((item, index) => (
                                        <tr key={item._id}>
                                            <td>
                                                {(currentPage - 1) * limit + index + 1}
                                            </td>

                                            <td>
                                                {item.createdBy?.firstName}{" "}
                                                {item.createdBy?.lastName}
                                            </td>

                                            <td>{item.comments}</td>

                                            <td>{item.modeOfContact ? item.modeOfContact.charAt(0).toUpperCase() + item.modeOfContact.slice(1) : "-"}</td>
                                            <td

                                            >
                                                <span
                                                    className={
                                                        item.status === "completed"
                                                            ? styles.statusCompleted
                                                            : item.status === "inprogress"
                                                                ? styles.statusInProgress
                                                                : styles.statusPending
                                                    }
                                                >
                                                    {item.status}
                                                </span>
                                            </td>

                                            <td>
                                                {new Date(item.createdAt).toLocaleString("en-IN", {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: true,
                                                })}
                                            </td>

                                            {/* <td>
                                                <div className={styles.actions}>
                                                    <FaEdit
                                                        className={styles.icon}
                                                        onClick={() => {
                                                            setEditData(item);
                                                            setShowPopup(true);
                                                        }}
                                                    />
                                                    <FaTrash
                                                        className={styles.icon}
                                                        onClick={() => {
                                                            setSelectedItem(item);
                                                            setDeleteModalOpen(true);
                                                        }}
                                                    />

                                                </div>
                                            </td> */}

                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* PAGINATION */}
                <div className={styles.paginationWrapper}>
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                    />

                    <select
                        className={styles.inputsbtn}
                        value={limit}
                        onChange={(e) => {
                            setLimit(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                    >
                        <option value={10}>10 rows</option>
                        <option value={25}>25 rows</option>
                        <option value={50}>50 rows</option>
                    </select>
                </div>

                <div className={styles.footerButtons}>
                    <button
                        className={styles.cancelBtn}
                        onClick={() => navigate("/dashboard/HelpCenterAdmin")}
                    >
                        Close
                    </button>
                </div>
            </div>

            {/* ADD RESPONSE POPUP */}
            {showPopup && (
                <PopupWrapper
                    onClose={() => {
                        setShowPopup(false);
                        setEditData(null);
                        refetch();
                    }}
                >
                    <HelpCenterUserAdminAdd
                        enquiryId={enquiryId}
                        editData={editData}
                        onClose={() => {
                            setShowPopup(false);
                            setEditData(null);
                            refetch();
                        }}
                    />
                </PopupWrapper>
            )}
            {/* DELETE CONFIRM POPUP */}
            <DeleteConfirmModalLogout
                isOpen={deleteModalOpen}
                onConfirm={confirmDelete}
                onCancel={() => {
                    setDeleteModalOpen(false);
                    setSelectedItem(null);
                }}
                title="Are You Sure?"
                heading="Delete Ticket Response"
                content={`Are you sure you want to delete "${selectedItem?.comments}"? This action cannot be restored.`}
            />

        </div>
    );
};

export default HelpCenterAdminView;
